import { render, staticRenderFns } from "./Parametrizacion.vue?vue&type=template&id=097a0123"
import script from "./Parametrizacion.vue?vue&type=script&lang=js"
export * from "./Parametrizacion.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports